import { Flex, Form, Input, Typography } from "antd";
import { formRules } from "../../constant";

import PrimaryButton from "../Forms/PrimaryButton";

const { Title } = Typography;
const inputClass =
  "h-[47.6px] bg-[#FFFFFF] border border-[#D9D9D9] text-[#000000] text-base rounded-2xl w-full p-3.5 focus:outline-none focus:border-transparent";

const Password = ({
  handleFinish,
  setStep,
  formData,
  setFormData,
  title,
  loading,
  is_customer = false,
}) => {
  const [form] = Form.useForm();
  return (
    <>
      <Title className="input-css" level={3}>
        {title}
      </Title>

      <Form
        className={is_customer ? "max-w-full mx-auto" : "mt-8"}
        name="trigger"
        layout="vertical"
        autoComplete="off"
        form={form}
        onFinish={handleFinish}
        initialValues={formData}
        requiredMark={is_customer ? false : true}
      >
        <Form.Item
          label={
            is_customer ? (
              <span className="block mb-2 text-xl font-manrope font-normal text-[#000000]">
                Enter Password
              </span>
            ) : (
              "Password"
            )
          }
          name="password"
          rules={formRules.password}
        >
          <Input.Password
            size="large"
            maxLength={20}
            className={is_customer ? inputClass : ""}
          />
        </Form.Item>

        <Form.Item
          label={
            is_customer ? (
              <span className="block mb-2 text-xl font-manrope font-normal text-[#000000]">
                Confirm Password
              </span>
            ) : (
              "Confirm Password"
            )
          }
          name="confirm"
          dependencies={["password"]}
          rules={formRules.confirmPass()}
        >
          <Input.Password
            size="large"
            maxLength={20}
            className={is_customer ? inputClass : ""}
          />
        </Form.Item>

        <div className={`w-full flex justify-center gap-4 mt-12 mt-4`}>
          <PrimaryButton
            text="Previous"
            type="button"
            onClick={() => {
              setFormData({ ...formData, ...form.getFieldsValue() });
              setStep((prev) => prev - 1);
            }}
            className={is_customer ? "ml-[-42px] w-fit" : "fit"}
            btnType="secondary"
          />
          <PrimaryButton
            noIcon={is_customer ? false : true}
            text="Proceed"
            type="submit"
            className=" w-fit"
            loading={loading}
          />
        </div>
      </Form>
    </>
  );
};

export default Password;
